var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._e(),(!_vm.loading)?_c('div',[_c('chart',{attrs:{"data":_vm.data,"options":_vm.options}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }